// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2VOkT","newExpiryDate":"styles_newExpiryDate__1DRJd","footer":"styles_footer__38rpU"};